/**
 * Récupère un token d'authentification auprès du serveur
 * @returns {Promise<string>} Le token d'accès
 * @throws {Error} En cas d'échec de l'authentification
 */
export const getAuthToken = async () => {
    try {
        const authResponse = await fetch(`${process.env.REACT_APP_HOTE}/obtenir-token/`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username: process.env.REACT_APP_USERNAME,
                password: process.env.REACT_APP_PASSWORD
            })
        });

        if (!authResponse.ok) {
            throw new Error(`Erreur d'authentification: ${authResponse.status}`);
        }

        const authData = await authResponse.json(); // <- D'abord récupérer les données
        
        if (authData.access) {
            localStorage.setItem("access_token", authData.access);
            localStorage.setItem("refresh_token", authData.refresh);
            return authData.access;
        } else {
            throw new Error('Token non trouvé dans la réponse');
        }
    } catch (error) {
        console.error('Erreur lors de la récupération du token:', error);
        throw new Error('Impossible de se connecter au service de vérification');
    }
};